export const UPDATED_CONTENT = 'UPDATED_CONTENT';
export const CLEAR_UPDATED_CONTENT = 'CLEAR_UPDATED_CONTENT';
export const SET_HEADER_META = 'SET_HEADER_META';